import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { authApi } from './lib/api';

// App (authenticated) pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PatientsPage from './pages/PatientsPage';
import PatientDetailPage from './pages/PatientDetailPage';
import ConsultationPage from './pages/ConsultationPage';
import NewConsultationPage from './pages/NewConsultationPage';
import AppLayout from './components/layout/AppLayout';

// Marketing pages
import MarketingHome from './marketing/MarketingHome';
import MarketingFeatures from './marketing/MarketingFeatures';
import MarketingPricing from './marketing/MarketingPricing';
import MarketingAbout from './marketing/MarketingAbout';
import MarketingContact from './marketing/MarketingContact';

function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/app/login" replace />;
  return children;
}

export default function App() {
  const { setUser, logout } = useAuthStore();

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      authApi.me()
        .then(setUser)
        .catch(() => logout());
    }
  }, []);

  return (
    <Routes>
      {/* Public marketing routes */}
      <Route path="/" element={<MarketingHome />} />
      <Route path="/features" element={<MarketingFeatures />} />
      <Route path="/pricing" element={<MarketingPricing />} />
      <Route path="/about" element={<MarketingAbout />} />
      <Route path="/contact" element={<MarketingContact />} />

      {/* App routes */}
      <Route path="/app/login" element={<LoginPage />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="patients" element={<PatientsPage />} />
        <Route path="patients/:id" element={<PatientDetailPage />} />
        <Route path="consultations/new" element={<NewConsultationPage />} />
        <Route path="consultations/:id" element={<ConsultationPage />} />
      </Route>
    </Routes>
  );
}
